/* globals define */
/*
  Purpose:
    - UI controller for the my account drawer.

  Dependencies
    - Mustache
    - jQuery
    - THD Namespace
    - body-scroll-lock
*/
(function closure(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(
      'header.myaccountdrawer', ['jquery', 'mustache', 'body-scroll-lock', 'header.data', 'header.analytics', 'header.mask', 'hfConfig', 'thd-customer'],
      (jQuery, Mustache, bodyScrollLock, headerData, headerAnalytics, headerMask, hfConfig, thdcustomer) => factory(root, jQuery, Mustache, bodyScrollLock, headerData, headerAnalytics, headerMask, hfConfig, thdcustomer)
    );
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /*eslint-disable*/
    var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.myaccdrawer = factory(root, jQuery, Mustache, THD.HFApp.data, THD.HFApp.analytics);
    /* eslint-enable */
  }
}(this, (root, $, Mustache, bodyScrollLock, headerData, headerAnalytics, headerMask, hfConfig, thdcustomer) => {
  const myaccdrawer = {};
  const privateMethods = {};
  privateMethods.templates = {};

  privateMethods.closeOnSearchOpen = function _closeOnSearchOpen(event, isOpen) {
    if (isOpen) {
      privateMethods.toggleMyAccountDrawer(event, false);
    }
  };

  privateMethods.removeB2XLinks = function _removeB2XLinks() {
    if (thdcustomer.default.isB2XCustomer) {
      $('#B2CRedirect').remove();
      $('#MobiletaskLinkPro').remove();
      $('#MobiletaskLinkFav').remove();
      $('#headerOrderStatus').remove();
      $('#MobileTasklinkList').removeClass('u--hide');
      $('#FavoritesLink').attr('href', 'https://' + hfConfig.nonSecureHostName + '/b2b/account/view/list/summary');
    } else {
      $('#B2XRedirect').remove();
      $('#b2xheaderOrderStatus').remove();
      $('#MobileTasklinkList').removeClass('u--hide');
    }
  };

  privateMethods.toggleMyAccountDrawer = function _toggleMyAccountDrawer(event, open) {
    const menuShown = (typeof open === 'undefined') ? true : open;
    const caratIcon = $('.ma-profile__carat');
    const myAccountDrawer = $('#ma-drawer-content');
    const isClosed = myAccountDrawer.hasClass('ma-drawer-content--closed');
    const maDrawer = document.querySelector('#ma-drawer-content');
    event.preventDefault();
    event.stopPropagation();

    if (isClosed && menuShown) {
      $(document).trigger('closeHeaderTooltips');
      $(document).trigger('closeAllMenus');
      $(document).trigger('showSimpleFlyout', false);
      $(document).trigger("headerMask-show", true);
      bodyScrollLock.disableBodyScroll(maDrawer);
      caratIcon.removeClass('ma-profile__carat--closed').addClass('ma-profile__carat--open');
      myAccountDrawer.removeClass('ma-drawer-content--closed').addClass('ma-drawer-content--open');
    } else {
      bodyScrollLock.enableBodyScroll(maDrawer);
      $(document).trigger("headerMask-show", false);
      caratIcon.removeClass('ma-profile__carat--open').addClass('ma-profile__carat--closed');
      myAccountDrawer.removeClass('ma-drawer-content--open').addClass('ma-drawer-content--closed');
    }
  };

  // bind to all the necessary elements
  privateMethods.initialize = function initialize() {
    // delegate to all the things
    privateMethods.removeB2XLinks();

    $(document)
      .on('click', '#myAccountProfileButton', privateMethods.toggleMyAccountDrawer)
      .on('searchState', privateMethods.closeOnSearchOpen)
      .on('toggleMyAccountDrawer', privateMethods.toggleMyAccountDrawer);
  };

  /*
   * Public Methods
   */

  myaccdrawer.init = function init() {
    // Do it before ready - cause we rock
    privateMethods.initialize();

    // Start loading the data now
    headerData.init();

    return this;
  };

  myaccdrawer.getPrivateMethods = function getPrivateMethods() {
    return privateMethods;
  };

  return myaccdrawer;
}));
